// token
export const TOKEN = 'token';
export const CAMPAIGN_ANSWERS = 'campaignAnswers';
export const CAMPAIGN_RESULT_SAVED = 'campaignResultSaved';
export const SHOW_DASHBOARD_PRACTICE_CONCEPTS = 'showPracticeStars';
export const PRACTICE_TUTORIAL_STAGE = 'practiceTutorialStage';
export const IS_WIZMO_USER = 'isWizmoUser';



// WEBPACK FOOTER //
// ./app/constants/cookieNames.js